export default __webpack_public_path__ + "static/media/DoubleHelix.11c53c58.png";